//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapState } from "vuex";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";

import Modals from "@/pages/fabricInterface/mixins/left-menu";

export default {
    name: "UserAccount",
    components: {
        AQAvatar,
        AQMenu
    },
    mixins: [Modals],
    props: {
        isExternal: { type: Boolean, default: false },
        isMobile: { type: Boolean, default: false }
    },
    data() {
        return {
            accountMenu: []
        };
    },
    computed: {
        ...mapState("userProfile", ["needsTaskRedirect"]),
        ...mapGetters("userProfile", ["userDataDetails", "userProfileImage"]),
        buildOptions() {
            const options = [{ value: "logout", label: this.$t("fabricInterface.logout") }];
            if (!this.isExternal && !this.needsTaskRedirect) {
                options.unshift({ value: "myAccount", label: this.$t("fabricInterface.myAccount") });
            }
            return options;
        },
        accountMenuProps() {
            return {
                options: this.buildOptions,
                titleMenu: true,
                fromAccountMenu: true,
                maxWidth: "110px",
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                mobilePadding: this.isMobile
            };
        }
    },
    methods: {
        setUserType(value) {
            let type;
            if (value.systemType === "TOAUTHUSR") {
                type = "systemExternalUser";
            } else if (value.systemType === "TSYS") {
                type = "systemInternalUser";
            } else {
                type = (value.sourceType === "AD" || value.type === "TSAMLUSR" || value.type === "TOPENIDUSR" || value.realmId)
                    ? "externalUser" : "userPlatform";
            }
            return type;
        },
        getImagePath() {
            return this.userDataDetails.avatarPath ? `/identity/tenants/users/image/${this.userDataDetails.id}/m` : null;
        },
        listAction(option) {
            const [action] = option;
            if (action.value === "logout") {
                this.logout();
            } else if (action.value === "myAccount") {
                this.toProfile();
            }
            this.accountMenu = [];
        }
    }
};
